import React from 'react';
import RadioInp, { Label } from './Radio.stc';

export const RadioGroup = ({ children, value, ...restOfProps }) => {
    return (
        <div>
            {React.Children.map(children, (child) =>
                React.cloneElement(child, { selected: value, ...restOfProps })
            )}
        </div>
    );
};

function Radio(props) {
    const { children, selected, value, type, ...restOfProps } = props;
    const checked = selected == value;
    return (
        <Label type={type} isActive={!restOfProps.disabled}>
            <RadioInp checked={checked} value={value} {...restOfProps} />
            {children}
        </Label>
    );
}

export default Radio;
